import { Loader } from "@googlemaps/js-api-loader";
import { Controller } from "@hotwired/stimulus";
import { buildInfoBox } from "../views/googlemap";

// Connects to data-controller="googlemap"
export default class extends Controller {
  static targets = ["map", "search", "localize"];

  connect() {
    this.translations = {
      opening: this.element.dataset.openingTranslation,
      address: this.element.dataset.addressTranslation,
    };
    this.chocolateFactories = JSON.parse(this.element.dataset.chocolateFactories);
    this.isFranchise = this.element.dataset.isFranchise;

    this.mapEl = this.mapTarget
    this.searchEl = this.hasSearchTarget ? this.searchTarget : null;
    this.localizeEl = this.hasLocalizeTarget ? this.localizeTarget : null;
    this.lang = this.element.dataset.language;

    this.init();
  }

  async init() {
    if (this.isFranchise == "true") {
      this.desktopCenter = { lat: 48.940640, lng: -72.174527 };
      this.tabletCenter = { lat: 49.145642, lng: -74.425124 };
      this.mobileCenter = { lat: 50.275604, lng: -74.444626 };
    } else {
      this.desktopCenter = { lat: 46.799655, lng: -71.25247917456055 };
      this.tabletCenter = { lat: 46.780541, lng: -71.250985 };
      this.mobileCenter = { lat: 46.780541, lng: -71.250985 };
    }

    let center = this.mobileCenter;
    if (window.innerWidth > 1023) {
      center = this.desktopCenter;
    } else if (window.innerWidth > 767) {
      center = this.tabletCenter;
    }

    const loader = new Loader({
      apiKey: this.element.dataset.secret,
      language: this.lang,
    });

    const google = await loader.load();

    this.placesData = {};

    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

    const { places, Autocomplete } = await google.maps.importLibrary("places");

    this.AdvancedMarkerElement = AdvancedMarkerElement;
    this.PinElement = PinElement;
    this.google = google;
    this.places = places;
    this.Autocomplete = Autocomplete;


    // this = {
    //   AdvancedMarkerElement,
    //   PinElement,
    //   google,
    //   places,
    //   Autocomplete
    // };

    let zoom = 13;
    if (this.isFranchise == "true") {
      zoom = window.innerWidth > 767 ? 6 : 5
    } else {
      zoom = window.innerWidth > 1023 ? 13 : 12
    }
    this.mapObject = new Map(this.mapEl, {
      center: center,
      disableDefaultUI: true,
      mapId: this.isFranchise == "true" ? "fc1afc3dad47e774" : "a29abcf4944d187f",
      zoom: zoom,
      zoomControl: true,
    });

    this.isLoading = false;

    this.infoWindow = undefined;
    this.currentMarkerContent = undefined;

    this.markers = [];
    this.userLocation = null;

    this.setupLocations();

    this.googleMapsResizeListener = this.onResize.bind(this);
    window.addEventListener("resize", this.googleMapsResizeListener);

    if (this.searchEl) {
      this.setupSearch();
      this.localizeEl.addEventListener("click", this.handleLocalize);
    }

    if (this.element.dataset.autoLocate == "true") {
      this.handleLocalize();
    }
  };

  setupLocations() {
    for (const marker of this.markers) {
      marker.setMap(null);
    }

    this.markers.length = 0;

    for (const place of this.chocolateFactories) {
      this.setupLocation(place);
    }
    if (this.userLocation) {
      this.placeUserLocationMarker();
    }
  }
  setupLocation = (place) => {
    const markerContent = document.createElement("div");
    markerContent.setAttribute("class", "transition-all scale-[0.6] hover:scale-[1] [&.--selected]:scale-[1]");

    markerContent.innerHTML = `
        <img src="data:image/svg+xml;base64,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"/>
      `;

    const AdvancedMarkerElement = this.AdvancedMarkerElement;

    const marker = new AdvancedMarkerElement({
      content: markerContent,
      map: this.mapObject,
      position: { lng: parseFloat(place.lng), lat: parseFloat(place.lat) },
    });

    this.google.maps.event.addListener(marker, "click", () =>
      this.handleMarkerClick(place, marker, markerContent)
    );

    this.markers.push(marker);
  };

  placeUserLocationMarker() {
    const pin = new this.PinElement({
      background: "#E52318",
      borderColor: "#C5281E",
      glyphColor: "#C5281E",
      scale: 1.25
    });
    const marker = new this.AdvancedMarkerElement({
      map: this.mapObject,
      position: this.userLocation,
      content: pin.element,
    });
    this.markers.push(marker);
  }
  setupSearch() {
    this.autocompleteObject = new this.Autocomplete(this.searchEl, {});

    this.autocompleteObject.addListener("place_changed", () => {
      const place = this.autocompleteObject.getPlace();
      this.moveToLocation(place.geometry.location.lat(), place.geometry.location.lng())
    });
  }

  async handleMarkerClick(place, marker, markerContent) {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;

    let placeData = this.placesData[place.place_id];

    if (!placeData) {
      placeData = await this.getPlace(place.place_id);
      this.placesData[place.place_id] = placeData;
    }

    this.isLoading = false;

    const address = this.processAddress(placeData.address_components);

    if (window.innerWidth > 767) {
      this.closeInfoWindow();

      const InfoWindow = this.google.maps.InfoWindow;

      this.infoWindow = new InfoWindow({
        closeBoxURL: "",
        content: buildInfoBox(place, placeData, this.translations, address, false),
        maxWidth: 468,
        minWidth: 300,
        maxHeight: 550,
      });

      this.infoWindow.open({
        anchor: marker,
        map: this.mapObject,
      });
      this.infoWindow.focus();

      google.maps.event.addListener(this.mapObject, "click", () => {
        this.closeInfoWindow();
      });
      markerContent.classList.add("--selected");
    } else {
      this.dispatch("openLocationPopup", { detail: { content: buildInfoBox(place, placeData, this.translations, address, true) } });
    }

    this.currentMarkerContent = markerContent;

  }


  processAddress(addressComponents) {
    let addressObject = {};
    addressComponents.forEach(function (component) {
      switch (component.types[0]) {
        case 'street_number':
          addressObject.streetNumber = component.long_name;
          break;
        case 'route':
          addressObject.streetName = component.short_name;
          break;
        case 'neighborhood': case 'locality':    // North Hollywood or Los Angeles?
          addressObject.city = component.long_name;
          break;
        case 'administrative_area_level_1':     //  Note some countries don't have states
          addressObject.state = component.short_name;
          break;
        case 'postal_code':
          addressObject.zip = component.long_name;
          break;
        case 'country':
          addressObject.country = component.long_name;
          break;
      }
    });

    return addressObject.streetNumber + " " + addressObject.streetName + "</br>" + addressObject.city + ", " + addressObject.state + " " + addressObject.zip + "</br>" + addressObject.country;
  };

  getPlace(placeId) {
    var request = {
      fields: ["name", "formatted_phone_number", "opening_hours", "address_components", "url", "formatted_address"],
      language: this.lang,
      placeId,
    };

    return new Promise((resolve) => {
      const callback = (data, status) => {
        if (status == this.google.maps.places.PlacesServiceStatus.OK) {
          resolve(data);
        }
      };

      const service = new this.google.maps.places.PlacesService(this.mapObject);
      service.getDetails(request, callback);
    });
  }


  closeInfoWindow() {
    if (this.infoWindow) {
      this.infoWindow.close();
      this.currentMarkerContent.classList.remove("--selected");
    }

    this.infoWindow = undefined;
    this.currentMarkerContent = undefined;
  }



  handleLocalize = async () => {
    this.localizeEl.classList.add("loading");
    this.isLoading = true;

    const location = await this.getLocation();

    this.isLoading = false;

    if (!location) {
      return;
    }

    this.searchEl.value = "";
    this.localizeEl.classList.remove("loading");
    this.moveToLocation(location.coords.latitude, location.coords.longitude)
  };

  moveToLocation(lat, lng) {
    this.mapObject.panTo({ lat: lat, lng: lng });
    this.userLocation = { lat: lat, lng: lng };
    this.setupLocations();
  }

  getLocation() {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(undefined);

        return;
      }

      navigator.geolocation.getCurrentPosition(resolve);
    });
  }



  onResize() {
    if (this.isFranchise == "true") {
      this.mapObject.setZoom(window.innerWidth > 767 ? 6 : 5);
    } else {
      this.mapObject.setZoom(window.innerWidth > 767 ? 13 : 12);
    }
  }

  disconnect() {
    window.removeEventListener("resize", this.googleMapsResizeListener);
    delete this.mapObject;
  }
}
